__turbopack_context__.v({
  "active": "Navbar-module-scss-module__LOVq6q__active",
  "container": "Navbar-module-scss-module__LOVq6q__container",
  "desktop": "Navbar-module-scss-module__LOVq6q__desktop",
  "desktopLanguageSwitcher": "Navbar-module-scss-module__LOVq6q__desktopLanguageSwitcher",
  "dot": "Navbar-module-scss-module__LOVq6q__dot",
  "dropdownArrow": "Navbar-module-scss-module__LOVq6q__dropdownArrow",
  "dropdownContainer": "Navbar-module-scss-module__LOVq6q__dropdownContainer",
  "expanded": "Navbar-module-scss-module__LOVq6q__expanded",
  "header": "Navbar-module-scss-module__LOVq6q__header",
  "iconHidden": "Navbar-module-scss-module__LOVq6q__iconHidden",
  "iconVisible": "Navbar-module-scss-module__LOVq6q__iconVisible",
  "leftSection": "Navbar-module-scss-module__LOVq6q__leftSection",
  "link": "Navbar-module-scss-module__LOVq6q__link",
  "linkContainer": "Navbar-module-scss-module__LOVq6q__linkContainer",
  "linkContent": "Navbar-module-scss-module__LOVq6q__linkContent",
  "loginButton": "Navbar-module-scss-module__LOVq6q__loginButton",
  "logo": "Navbar-module-scss-module__LOVq6q__logo",
  "logoLink": "Navbar-module-scss-module__LOVq6q__logoLink",
  "menubar": "Navbar-module-scss-module__LOVq6q__menubar",
  "menulist": "Navbar-module-scss-module__LOVq6q__menulist",
  "menulistScroll": "Navbar-module-scss-module__LOVq6q__menulistScroll",
  "mobile": "Navbar-module-scss-module__LOVq6q__mobile",
  "mobileLanguageSwitcher": "Navbar-module-scss-module__LOVq6q__mobileLanguageSwitcher",
  "mobileLoginButton": "Navbar-module-scss-module__LOVq6q__mobileLoginButton",
  "mobileUserButton": "Navbar-module-scss-module__LOVq6q__mobileUserButton",
  "pulseLink": "Navbar-module-scss-module__LOVq6q__pulseLink",
  "rightSection": "Navbar-module-scss-module__LOVq6q__rightSection",
  "scrolled": "Navbar-module-scss-module__LOVq6q__scrolled",
  "submenu": "Navbar-module-scss-module__LOVq6q__submenu",
  "submenuItem": "Navbar-module-scss-module__LOVq6q__submenuItem",
  "submenuItemActive": "Navbar-module-scss-module__LOVq6q__submenuItemActive",
  "themeToggleDesktop": "Navbar-module-scss-module__LOVq6q__themeToggleDesktop",
  "themeToggleMobile": "Navbar-module-scss-module__LOVq6q__themeToggleMobile",
});
